import { useQuery } from 'react-query';

import { getTagsPerContract as queryFn } from 'api/endPoints/getTagsPerContract';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetTagsPerContract = (params: QueryParams) => {
    return useQuery<QueryResponse[], QueryError, QueryResponse[], [QueryKeys, unknown]>({
        queryKey: ['getTagsPerContract', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.contractId),
    });
};

export interface QueryParams {
    contractId: number | undefined;
}

export interface QueryResponse {
    id: number;
    name: string;
}
